import firebase from 'firebase'
import {NotificationContainer, NotificationManager} from 'react-notifications';


export const initializePush = () => {

    if (firebase.messaging.isSupported()) {
        const messaging = firebase.messaging();

        messaging.requestPermission()
            .then(() => {
                console.log("Have Permission");
                return messaging.getToken();
            })
            .then(token => {
                console.log("FCM Token:", token);
                localStorage.setItem('fcm-token', JSON.stringify(token))
                //you probably want to send your new found FCM token to the
                //application server so that they can send any push
                //notification to you.
            })
            .catch(error => {
                if (error.code === "messaging/permission-blocked") {
                    console.log("Please Unblock Notification Request Manually");
                } else {
                    console.log("Error Occurred", error);
                }
            });
        messaging.onMessage(payload => {
            console.log(payload)
            console.log(payload.notification)
           // alert(payload.notification.title, payload.notification.body);
            NotificationManager.info(payload.notification.body, payload.notification.title, 30000);
            //this is the function that gets triggered when you receive a
            //push notification while you’re on the page. So you can
            //create a corresponding UI for you to have the push
            //notification handled.
        });
    }
};


// WEBPACK FOOTER //
// ./src/fcmInicjalize/initialize.js